// DynamicZoneInput.tsx
import { useFormContext, useFieldArray } from 'react-hook-form';
import { Button } from 'react-admin';
import { DynamicZoneInputItem } from './DynamicZoneInputItem';

const DynamicZoneInput = ({ source, isEditing = false }: { source: string, isEditing?: boolean }) => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: source,
  });

  return (
    <div>
      {fields.map((item, index) => (
        <DynamicZoneInputItem
          key={item.id}
          source={source}
          index={index}
          onRemove={() => remove(index)}
          isEditing={isEditing}
        />
      ))}

      <Button
        label="Agregar bloque"
        onClick={() =>
          append({
            __component: 'shared.rich-text',
            content: '',
          })
        }
      />
    </div>
  );
};

export default DynamicZoneInput;
